import { Icon } from '@drone-js/core';
import { useNavHeader } from './useNavHeader';
import * as React from 'react';

export const useSetNavHeader = (
    title: string,
    onBackButtonClick: () => void,
    hideBackButton: Boolean = false,
    customLogo?: string
) => {
    const { setNavHeader, clearNavHeader, setShowNavHeader } = useNavHeader();

    React.useEffect(() => {
        setShowNavHeader(!hideBackButton);
        setNavHeader({
            header: title,
            onButtonClick: onBackButtonClick,
            buttonIcon: <Icon id="fill.arrow.thin-back" size="14" />,
            customLogo,
        });
        return clearNavHeader;
    }, [hideBackButton]);
};
